import { CustomEventTarget } from 'components/eventTarget/EventTarget';
import { IVideoControllerComponentsCommonProps } from 'components/videoElementController/IVideoElementController';
import {
  EVideoElementControllerBusEvent,
  IVideoElementControllerBusEventsMap,
  TVideoControllerEventBus,
} from 'components/videoElementController/VideoElementController.events';
import { bind } from 'utils/bind';

import {
  TCustomEventsMap,
  EVideoControllerCustomEvent,
  ICustomEventPayload,
} from './CustomEventsEmitter.events';

export class CustomEventsEmitter extends CustomEventTarget<TCustomEventsMap> {
  private _eventsMap = {
    [EVideoElementControllerBusEvent.PLAYING]: this._handlePlaying,
    [EVideoElementControllerBusEvent.LOADING]: this._handleLoading,
    [EVideoElementControllerBusEvent.VIDEO_PAUSE]: this._handlePause,
    [EVideoElementControllerBusEvent.CLICK]: this._handleClick,
    [EVideoElementControllerBusEvent.DESTROY]: this.destroy,
    [EVideoElementControllerBusEvent.NATIVE_EVENT]: this._handleNativeEvent,
    [EVideoElementControllerBusEvent.UPDATE_PLAYER_RESOLUTION]: this._handleUpdatePlayerResolution,
    [EVideoElementControllerBusEvent.VIDEO_PLAYBACK_STATE_CHANGED]:
      this._handleVideoPlaybackStateChange,
    [EVideoElementControllerBusEvent.TIME_UPDATE_NATIVE]: this._handleTimeUpdate,
  };

  private readonly _eventBus: TVideoControllerEventBus;

  constructor(props: IVideoControllerComponentsCommonProps) {
    super();

    this._eventBus = props.eventBus;
    this.init();
  }

  @bind
  public destroy() {
    this._eventBus.toggleSubscriptionBulk({
      action: 'unsubscribe',
      callbacks: this._eventsMap,
    });
  }

  @bind
  public init() {
    this._eventBus.toggleSubscriptionBulk({
      action: 'subscribe',
      callbacks: this._eventsMap,
    });
  }

  @bind
  private _handlePlaying(
    e: IVideoElementControllerBusEventsMap[EVideoElementControllerBusEvent.PLAYING],
  ) {
    this.emitEvent(EVideoControllerCustomEvent.PLAYING, e);
  }

  @bind
  private _handleLoading() {
    this.emitEvent(EVideoControllerCustomEvent.LOADING, {});
  }

  @bind
  private _handlePause() {
    this.emitEvent(EVideoControllerCustomEvent.PAUSE, {});
  }

  @bind
  private _handleClick(e: ICustomEventPayload) {
    this.emitEvent(EVideoControllerCustomEvent.CLICK, { originalEvent: e.originalEvent });
  }

  @bind
  private _handleNativeEvent(
    e: IVideoElementControllerBusEventsMap[EVideoElementControllerBusEvent.NATIVE_EVENT],
  ) {
    this.emitEvent(EVideoControllerCustomEvent.NATIVE_EVENT, e);
  }

  @bind
  private _handleUpdatePlayerResolution(
    e: IVideoElementControllerBusEventsMap[EVideoElementControllerBusEvent.UPDATE_PLAYER_RESOLUTION],
  ) {
    this.emitEvent(EVideoControllerCustomEvent.UPDATE_PLAYER_RESOLUTION, e);
  }

  @bind
  private _handleTimeUpdate(
    e: IVideoElementControllerBusEventsMap[EVideoElementControllerBusEvent.TIME_UPDATE_NATIVE],
  ) {
    this.emitEvent(EVideoControllerCustomEvent.TIME_UPDATE, e);
  }

  @bind
  private _handleVideoPlaybackStateChange(
    e: IVideoElementControllerBusEventsMap[EVideoElementControllerBusEvent.VIDEO_PLAYBACK_STATE_CHANGED],
  ) {
    this.emitEvent(EVideoControllerCustomEvent.VIDEO_PLAYBACK_STATE_CHANGE, {
      prevState: e.prevState,
      nextState: e.nextState,
    });
  }
}
